// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"_cbc5a8fa","tag":"_a10c60ae","active":"_2aa94270"};